import React, { Children } from 'react';
import classNames from 'classnames';

import { isElementOfType } from '../../utilities/components';
import WpIcon from '../icon/WpIcon';
import WpButton from '../button/WpButton';

import './WpBanner.scss';

type Color = 'blue' | 'orange' | 'pink' | 'purple' | 'orange-purple';
const DEFAULT_TYPE = 'blue';

export interface Props {
  /**
   * Color of banner =>  Options: 'blue' | 'orange' | 'pink' | 'purple';
   * @default 'blue'
   */
  type?: Color;
  children?: React.ReactNode;
  icon?: React.ReactNode;
  onDismiss?: Function;
}

const classNamePrefix = 'WpBanner';

function WpBanner({ type = DEFAULT_TYPE, icon, children, onDismiss }: Props) {
  const iconLength = Children.count(icon);
  const customIcon = icon && icon && iconLength === 1 && isElementOfType(icon, WpIcon);

  const classes = classNames(classNamePrefix, `${classNamePrefix}--${type}`);

  return (
    <div className={classes} role="banner">
      {customIcon && <span className={`${classNamePrefix}__icon`}>{icon}</span>}
      <div className={`${classNamePrefix}__content`}>{children}</div>
      {onDismiss && (
        <div className={`${classNamePrefix}__close-btn`}>
          <WpButton size="sm" variant="tertiary" color="white" onClick={() => onDismiss()}>
            <WpIcon name="times" />
          </WpButton>
        </div>
      )}
    </div>
  );
}

export default WpBanner;
